import {initElements} from "../define/shared";

export default function initSplitBlock() {
    initElements(".split", split => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("animated");
                    return;
                }
                entry.target.classList.remove("animated");
            });
        }, {
            threshold: 0.5
        });

        observer.observe(split);
    });
}
